import {
  Card,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";

import { Strings } from "@app/constants";
import { useRequestState } from "@app/hooks";
import { selectDashboardState } from "../selector";

const TopPurchasedCarsTable = () => {
  const { data } = useRequestState({
    stateSelector: selectDashboardState,
  });

  const topCars = data?.topPurchasedCars || [];

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: "100%",
        borderRadius: 1,
        boxShadow: 3,
        overflowX: "auto",
      }}
    >
      <CardContent>
        <Typography
          fontFamily={fontFamily}
          fontWeight="700"
          mb={2}
          color="#1A202C"
        >
          {Strings.dashboard.topPunchedCars}
        </Typography>
        <Box sx={{ overflowX: "auto", p: 1, borderRadius: 2 }}>
          <Table
            sx={{
              alignItems: "center",
              justifyContent: "center",
              boxShadow: 3,
              borderRadius: 2,
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    color: "#474747",
                    borderTopLeftRadius: 18,
                    overflow: "hidden",
                  }}
                >
                  {Strings.dashboard.name}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    color: "#474747",
                  }}
                >
                  {Strings.dashboard.category}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    color: "#474747",
                  }}
                >
                  {Strings.dashboard.year}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    color: "#474747",
                  }}
                >
                  {Strings.dashboard.price}
                </TableCell>
                {/* <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    color: "#474747",
                    borderTopRightRadius: 18,
                    overflow: "hidden",
                  }}
                >
                  {Strings.dashboard.stock}
                </TableCell> */}
                {/* <TableCell
                  align="center"
                  sx={{
                    textAlign: "center",
                    fontFamily: fontFamily,
                    fontWeight: 600,
                    color: "#474747",
                  }}
                >
                  {Strings.dashboard.action}
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {topCars?.map((car: any, index: number) => (
                <TableRow key={index}>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 500,
                      color: "#5F5F5F",
                    }}
                  >
                    {car?.brand}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 500,
                      color: "#5F5F5F",
                    }}
                  >
                    {car?.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 500,
                      color: "#5F5F5F",
                    }}
                  >
                    {car?.year}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 500,
                      color: "#5F5F5F",
                    }}
                  >
                    {car?.price}
                  </TableCell>
                  {/* <TableCell
                    align="center"
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 500,
                      color: "#5F5F5F",
                    }}
                  >
                    {car?.stock}
                  </TableCell> */}
                  {/* <TableCell align="center">
                    <IconButton>
                      <Icon
                        icon="mdi:dots-vertical"
                        width={20}
                        height={20}
                        color="#5F5F5F"
                      />
                    </IconButton>
                  </TableCell> */}
                </TableRow>
              ))}
              {topCars?.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={6}
                    align="center"
                    sx={{
                      fontFamily: fontFamily,
                      fontWeight: 500,
                      color: "#5F5F5F",
                    }}
                  >
                    No top purchased cars available.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </CardContent>
    </Card>
  );
};

export { TopPurchasedCarsTable };
